var _path, _path2, _path3, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZingAuditorSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.944 172.25V113.786C221.944 105.012 217.707 96.779 210.568 91.6795L190.25 77.1666L161.272 55.4333C156.57 51.9065 150.85 50 144.972 50H95.1666C80.1629 50 68 62.1629 68 77.1666V131.5",
    stroke: "#00334E",
    strokeWidth: 18.1111
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.909 57.4091V96.9238C156.909 102.38 161.332 106.802 166.788 106.802H216.181",
    stroke: "#00334E",
    strokeWidth: 16.4644
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M203.833 158.667H86.1111C76.1086 158.667 68 166.776 68 176.778V206.608V231.111C68 241.114 76.1086 249.222 86.1111 249.222H231",
    stroke: "#00334E",
    strokeWidth: 18.1111
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 86.1111,
    y1: 190.361,
    x2: 231,
    y2: 190.361,
    stroke: "#7A4186",
    strokeWidth: 9.05555
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1111,
    y1: 208.472,
    x2: 231,
    y2: 208.472,
    stroke: "#7A4186",
    strokeWidth: 9.05555
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 86.1111,
    y1: 226.583,
    x2: 231,
    y2: 226.583,
    stroke: "#7A4186",
    strokeWidth: 9.05555
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZingAuditorSymbol);
export default __webpack_public_path__ + "static/media/ZingAuditorSymbol.58317debb7c2253d7710197444b7bf8b.svg";
export { ForwardRef as ReactComponent };